/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 05.03.15.
 */

angular.module('farmnet.partner.fendt').service('fendtVarioDocLocale', [
  'Locale',
  function(Locale) {
    'use strict';

    var base = 'fe.partner.fendt.varioDoc';
    var baseAlert = base + '.alert';

    var accountsRoute = '#/admin/settings';

    function getAlert(key) {
      return Locale.get(baseAlert + '.' + key);
    }

    this.alerts = {};

    this.alerts.supportedHint = getAlert('supportedHint').format(accountsRoute);
    this.alerts.willSendData = getAlert('willSendData');
    this.alerts.sendSuccess = getAlert('sendSuccess');
    this.alerts.sendFailure = getAlert('sendFailure');
  }
]);
